import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import baseAxios from 'src/utils/baseAxios';

export const GetProductTenantSales = createAsyncThunk(
  '/GetProductTenantSales',
  async () => {
    const response = await baseAxios.get(`/payment/productTenantSales`);
    return response.data;
  }
);

export const UpdateProductTenantSales = createAsyncThunk(
  '/UpdateProductTenantSales',
  async (data) => {
    const response = await baseAxios.post(`/payment/updateProductTenantSales`, {
      ProductTenantSalesId: data.Id,
      Price: data.Price,
      Active: data.IsActive
    });
    return response.data;
  }
);

export const GetSironexDashboard = createAsyncThunk(
  '/GetSironexDashboard',
  async () => {
    const response = await baseAxios.get(`/payment/GetSironexDashboard`);
    return response.data;
  }
);

export const GetPendingPayments = createAsyncThunk(
  '/GetPendingPayments',
  async () => {
    const response = await baseAxios.get('/payment/GetPendingPayments');
    return response.data;
  }
);

export const CorrectPendingPayment = createAsyncThunk(
  '/CorrectPendingPayment',
  async (repairOrderId) => {
    const response = await baseAxios.post('/payment/CorrectPendingPayment', { repairOrderId });
    return response.data;
  }
);

export const CancelPendingPayment = createAsyncThunk(
  '/CancelPendingPayment',
  async (repairOrderId) => {
    const response = await baseAxios.post('/payment/CancelPendingPayment', { repairOrderId });
    return response.data;
  }
);

const getPendingPaymentRows = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.ResponseObject)) return payload.ResponseObject;
  if (Array.isArray(payload?.responseObject)) return payload.responseObject;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.result)) return payload.result;
  if (Array.isArray(payload?.value)) return payload.value;
  return [];
};

const paymentSlice = createSlice({
  name: 'payment',
  initialState: {
    productTenantSales: [],
    sironexDashboard: null,
    pendingPayments: [],
    loading: false,
    error: null
  },
  reducers: {
    updateSironexDashboard: (state, action) => {
      state.sironexDashboard = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetProductTenantSales.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetProductTenantSales.fulfilled, (state, action) => {
        state.loading = false;
        state.productTenantSales = action.payload;
      })
      .addCase(GetProductTenantSales.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(UpdateProductTenantSales.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(UpdateProductTenantSales.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(UpdateProductTenantSales.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(GetSironexDashboard.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetSironexDashboard.fulfilled, (state, action) => {
        state.loading = false;
        state.sironexDashboard = action.payload;
      })
      .addCase(GetSironexDashboard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(GetPendingPayments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetPendingPayments.fulfilled, (state, action) => {
        state.loading = false;
        state.pendingPayments = getPendingPaymentRows(action.payload);
      })
      .addCase(GetPendingPayments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  }
});

export const paymentActions = paymentSlice.actions;
export default paymentSlice;
